import React from "react";

export default class ModalWindow extends React.Component {

    buildBody (isTextHtml) {

        // For text containing HTML in the DB such as headlines
        if (isTextHtml) {

            return (
                <div
                    className="modalbodyText"
                    dangerouslySetInnerHTML={{"__html": this.props.modalBody}}
                />
            );

        }


        return this.props.modalBody;


    }

    closeButtonExtension (extension) {

        if (typeof extension === "function") {

            extension();

        }

    }

    render () {

        return (

            <div
                className="modal fade"
                id={this.props.modalId}
                role="dialog"
            >
                <div className={`modal-dialog ${this.props.modalSize === undefined || this.props.modalSize === "modal-md" ? null : this.props.modalSize}`}>

                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className={`modal-title ${this.props.titleSize ? this.props.titleSize : '' }`}>
                                {this.props.modalTitle}
                            </h4>
                            {this.props.saveClose ? <button
                                className="btn btn-sm btn-light save-close"
                                data-dismiss="modal"
                                onClick={() => this.closeButtonExtension(this.props.onModalSaveClose)}
                                type="button"
                            >
                                Save & Close
                                                    </button> : null}
                            {this.props.hideCloseButton === true ? null : <button
                                className="close"
                                data-dismiss="modal"
                                onClick={() => this.closeButtonExtension(this.props.onModalClose)}
                                type="button"
                            >
                                &times;
                                                                          </button>}
                        </div>
                        <div className="modal-body">
                            {this.buildBody(this.props.isTextHtml)}
                        </div>
                    </div>

                </div>
            </div>

        );

    }

}
